import { SpacingType } from "@/lib/types";
import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  columnGap?: SpacingType;
  rowGap?: SpacingType;
}>;

export default function AsideMenu({ children, columnGap, rowGap }: Props) {
  const styles: CSSProperties = {
    borderRadius: "var(--border-radius-md)",

    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    rowGap: rowGap ? `var(--spacing-${rowGap})` : "var(--spacing-md)",
    columnGap: columnGap ? `var(--spacing-${columnGap})` : "var(--spacing-xs)",

    alignSelf: "start",
  };

  return (
    <aside aria-label="Page sections" style={styles}>
      {children}
    </aside>
  );
}
